import { render, staticRenderFns } from "./DetalleVersant.vue?vue&type=template&id=1458d0f2&"
import script from "./DetalleVersant.vue?vue&type=script&lang=js&"
export * from "./DetalleVersant.vue?vue&type=script&lang=js&"
import style0 from "./DetalleVersant.vue?vue&type=style&index=0&id=1458d0f2&prod&scope=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports